import { fetchEndpoint } from '../server/network'

// 获取优惠活动列表
export const activityList = () =>
	fetchEndpoint('/v2/ecapi.activity.list', 'POST', {})

// 获取优惠活动列表
export const activityDetail = id =>
	fetchEndpoint('/v2/ecapi.activity.get', 'POST', {
		activity: id //优惠id
	})

// 新获取优惠活动列表
export const activityNewList = (id, page, per_page) =>
	fetchEndpoint('/v2/ecapi.activity.newlist', 'POST', {
		id: id, //可忽略
		page: page, // 当前第几页
		per_page: per_page // 每页多少
	})

//展会
export const exhibition = (data) =>
	fetchEndpoint('/v2/ecapi.exhibit.get', 'POST', {
		country: data.country,
		month:data.month,
		country_old:data.country_old,
		year:data.year
	})
	
	export const exhibit = (data) =>
		fetchEndpoint('/v2/ecapi.exhibit.particulars', 'POST', {
			id: data,
		})	

//校园行
export const campusTour = (data) =>
	fetchEndpoint('/v2/ecapi.campustour.get', 'POST', {
		page: data.page,
		per_page: data.per_page,
		month:data.month,
		year:data.year,
		province: data.province,
		keyword:data.keyword,
	})		


// WEBPACK FOOTER //
// ./src/api/activity.js